<template>
  <div class="enrolling-sms-add">
    <div class="short-message-container">
      <div class="form-item form-height-low">
        <div class="item-title">
          <span class="title-icon-tip">*&nbsp;</span>号码池：
        </div>
        <div class="item-content">
          <div class="select-phone-container">
            <input class="select-phone-input" v-model="selectPhones" readonly placeholder="请选择平台学生手机号">
            <el-button class="select-phone-button" type="text" @click="addSendStudents">+选择学生</el-button>
            <el-button class="clear-phone-button" type="text" @click="clearSendStudents">清空</el-button>
          </div>
          <div class="select-phone-tip">
            已选<span style="color: #09A0FF;">{{selectPhones.length}}</span>条，最多可选100个学生号码
          </div>
        </div>
      </div>
      <div class="form-item form-height-high">
        <div class="item-title">
          <span class="title-icon-tip">*&nbsp;</span>短信内容：
        </div>
        <div class="item-content">
          变量短信使用字段，点击进入输入框 <br>
          <div @click="addVariableToContent(variable.name)" class="sms-variable" v-for="(variable, index) in smsVariable" :key="index">
            {{variable.name}}
          </div>
          <div class="sms-content-input">
            <el-input id="myInput" class="left-input" type="textarea" v-model="smsContent"/>
            <div class="right-input">
              <div class="sms-content-example" v-html="smsContentExample"></div>
            </div>
          </div>
          总计<span style="color: red;">{{smsContentLength}}</span>个字，{{smsStrip}}条/70字，具体以实际情况为准。
        </div>
      </div>
      <div class="form-item form-height-low">
        <div class="item-title">&nbsp;</div>
        <div class="item-content">
          <el-button class="send-sms-button" type="primary" @click="sendShortMessage">发送</el-button>
        </div>
      </div>
      <div class="form-item">
        <div class="item-title">
          <i class="el-icon-warning" style="color: #E54447;"></i>&nbsp;注意事项：
        </div>
        <div class="item-content">
          1、使用变量名发送短信，变量名会根据接收方信息自动填写相关内容; <br>
          2、超链接地址填写在短信内容中，便于核实，部分安卓系统存在超链接识别问题，需在超链接前后添加空格。<br>
          3、内容合法，不能发送房产、发票、移民等国家法律法规严格禁止的内容。
        </div>
      </div>
    </div>
    <div class="select-student-template">
      <el-drawer
        custom-class="custom-drawer"
        :visible.sync="drawer"
        :modal="false"
        size="50%">
        <TemplateDataGrid gridId="SmsEnrollStudentGrid"></TemplateDataGrid>
        <div class="drawer-menu">
          <el-button type="text" @click="hideDrawer">
            <i class="el-icon el-icon-close"></i>
          </el-button>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../../templates/TemplateDataGrid'
export default {
  name: 'EnrollingSmsAdd',
  components: { TemplateDataGrid },
  data () {
    return {
      drawer: false,
      smsVariable: [
        {
          name: '{姓名}',
          expression: '{trueName}',
          example: '张三'
        },
        {
          name: '{证件号}',
          expression: '{cardNo}',
          example: '1234****4321'
        },
        {
          name: '{报名审核状态}',
          expression: '{verifyStatus}',
          example: '审核通过'
        },
        {
          name: '{报名终审状态}',
          expression: '{verifyLastStatus}',
          example: '审核通过'
        },
        {
          name: '{免笔试审核状态}',
          expression: '{exemptStatus}',
          example: '通过'
        }
      ],
      smsContent: '',
      smsContentExample: '变量短信效果预览（用户随机举例）：',
      smsContentLength: 0,
      smsStrip: 0,
      selectPhones: [],
      selectData: []
    }
  },
  methods: {
    hideDrawer () {
      this.drawer = false
    },
    addSendStudents () {
      this.drawer = true
    },
    clearSendStudents () {
      this.selectPhones = []
      this.selectData = []
    },
    addVariableToContent (variable) {
      let textInput = document.getElementById('myInput')
      let insert = textInput.selectionStart
      this.smsContent = this.smsContent.substr(0, insert) + variable + this.smsContent.substr(insert)
    },
    replaceSmsContent (content, oldVariable, newVariable) {
      if (content.indexOf(oldVariable) !== -1) {
        content = content.split(oldVariable).join(newVariable)
      }
      return content
    },
    replaceHtmlSmsContent (content, oldVariable, newVariable) {
      if (content.indexOf(oldVariable) !== -1) {
        content = content.split(oldVariable).join(`<span style="color: red;">${newVariable}</span>`)
      }
      return content
    },
    reloadGridData () {
      this.$emit('reloadGridData')
    },
    sendShortMessage () {
      if (this.selectData.length === 0) {
        this.$message.warning('请选择发送号码')
        return
      }
      if (!this.smsContent) {
        this.$message.warning('请编辑短信内容')
        return
      }
      this.$confirm('确认发送短信吗？', '操作确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let smsExpression = this.smsContent
        this.smsVariable.forEach(v => {
          smsExpression = this.replaceSmsContent(smsExpression, v.name, v.expression)
        })
        this.$ajax({
          url: '/workspace/manager/enrolling/sms/sendSms',
          method: 'post',
          data: this.$qs.stringify({
            smsTemplate: this.smsContent,
            smsExpression: smsExpression,
            studentIds: this.selectData
          }, {arrayFormat: 'repeat'})
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.selectPhones = []
                this.selectData = []
                this.smsContent = ''
                this.reloadGridData()
                break
              }
              default: {
                this.$message.error(response.data['message'])
              }
            }
          }
        })
      }).catch(() => {})
    }
  },
  mounted () {
    this.$bus.$on('smsSelectPhones', data => {
      let addNum = 0
      let ignoreNum = 0
      data.forEach(select => {
        if (this.selectPhones.length < 100) {
          let phone = select.mobilePhone
          if (this.selectPhones.indexOf(phone) === -1) {
            addNum += 1
            this.selectPhones.push(phone)
            this.selectData.push(select.id)
          } else {
            ignoreNum += 1
          }
        } else {
          ignoreNum += 1
        }
      })
      if (addNum !== 0) {
        this.$message.success(`成功添加${addNum}条手机号`)
      } else {
        this.$message.warning(`成功添加${addNum}条手机号，忽略${ignoreNum}条`)
      }
    })
  },
  beforeDestroy () {
    this.$bus.$off('smsSelectPhones')
  },
  watch: {
    'selectPhones': function () {
      this.drawer = false
    },
    'smsContent': function () {
      this.smsContentExample = this.smsContent
      let example = this.smsContentExample
      this.smsVariable.forEach(v => {
        example = this.replaceHtmlSmsContent(example, v.name, v.example)
      })
      example = example.replace(/\r\n/g, '<br>')
      example = example.replace(/\n/g, '<br>')
      this.smsContentExample = example
      if (this.smsContentExample.length === 0) {
        this.smsContentExample = '变量短信效果预览（用户随机举例）：'
      }
      let content = this.smsContent
      let contentLength = content.replace('{', '').replace('}', '')
      this.smsContentLength = contentLength.length
      this.smsStrip = Math.ceil(this.smsContentLength / 70)
    }
  }
}
</script>

<style lang="scss">
.enrolling-sms-add{
  background-color: #fff;
  height: 100%;
  overflow-y: auto;
  & > .short-message-container{
    padding: 20px 0 0 30px;
    & > .form-item{
      & > .item-title{
        display: inline-block;
        width: 150px;
        float: left;
        .title-icon-tip{
          color: red;
        }
      }
      & > .item-content{
        display: inline-block;
        /*.check-module-radio {*/
        /*  margin-right: 20px;*/
        /*  .el-radio-button__inner{*/
        /*    border: 1px solid #DCDFE6;*/
        /*  }*/
        /*}*/
        .sms-variable{
          display: inline-block;
          padding: 2px 15px;
          font-size: 14px;
          margin: 10px 20px 10px 0;
          background-color: #ECF3FE;
          color: #3AAAFE;
        }
        .select-phone-container {
          .select-phone-input {
            display: inline-block;
            width: 450px;
            height: 30px;
          }
          .select-phone-button {
            color: #09A0FF;
            font-size: 14px;
            margin-left: 10px;
          }
          .clear-phone-button{
            color: red;
            font-size: 14px;
            margin-left: 10px;
          }
        }
        .sms-content-input {
          .left-input {
            width: 450px;
            float: left;
            margin-right: 5px;
          }
          .right-input {
            width: 350px;
            height: 250px;
            font-size: 14px;
            background-color: #EBECEE;
            display: inline-block;
            overflow-y: auto;
            .sms-content-example{
              padding: 20px 0 0 10px;
            }
          }
          .el-textarea__inner{
            height: 250px;
          }
        }
        .select-phone-tip{
          margin-top: 5px;
        }
        .send-sms-button{
          width: 100px;
        }
      }
    }
    .form-height-low {
      height: 80px;
    }
    .form-height-middle{
      height: 110px;
    }
    .form-height-high {
      height: 400px;
    }
  }
  .select-student-template{
    .drawer-menu {
      position: absolute;
      left: -30px;
      top: 50%;
      width: 30px;
      height: 36px;
      line-height: 36px;
      margin-top: -18px;
      background-color: #fff;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      box-shadow: -5px 0 5px rgba(0,0,0,.1);
      .el-button {
        width: 100%;
        height: 100%;
        font-size: 16px;
        text-align: center;
        color: #606266;
        padding: 0 0 0 2px;
        border: none;
        outline: 0;
        box-sizing: border-box;
        &:hover {
          color: #303133;
        }
      }
    }
    .custom-drawer{
      overflow: initial;
    }
  }
}
</style>
